import axios from "axios";
import {
  USERS_URL,
  USER_URL,
  commonUrl,
  userUrl,
  getUsersProfilePictureUrl,
  fetchBranchLogoUrl,
  RESULT_ANALYSIS_KEY,
  postRemoveCredsUrl,
  postResendCredsUrl,
} from "common/constants/apiUrls";
import {
  getData,
  postData,
  updateData,
  downloadData,
} from "networkManager/NetworkManager";

export const login = async (data) => {
  return await postData(userUrl.authenticate, data);
};

export const logout = async () => {
  return await getData(userUrl.logout);
};

export const createNewPassword = async (data) => {
  return postData(userUrl.setPassword, data);
};

export const removeCredentials = async (userId, data) => {
  return postData(postRemoveCredsUrl(userId), data);
};

export const resendCredentials = async (userId, data) => {
  return postData(postResendCredsUrl(userId), data);
};

export const forgetPassword = async (data) => {
  return postData(userUrl.forgetPassword, data);
};

export const getUserProfile = () => {
  return getData(userUrl.profile);
};

export const updateUserProfile = (payload) => {
  return updateData(userUrl.profile, payload);
};

export const inviteNewUser = (data) => {
  return postData(userUrl.invite, data);
};
export const inviteNewUserAPI = (data) => {
  return postData(userUrl.inviteAPI, data);
};
export const getUsers = async (params) => {
  let {
    role = "",
    pageNumber = "",
    pageSize = "",
    searchString = "",
    orderBy = "",
    filter = "",
    orderType = "",
    bankId = "",
    branchId = "",
    products = [],
    status,
  } = params;
  let url = "";
  let productFilterString = "";
  products?.forEach((el) => {
    productFilterString += `&ProductKey=${el}`;
  });
  if (role === "%23IA") {
    url =
      USERS_URL +
      `?Role=${role}&PageNumber=${pageNumber}&PageSize=${pageSize}&SearchString=${encodeURIComponent(
        searchString
      )}&OrderBy=${orderBy}&OrderType=${orderType}&Filter=${filter}&BankId=${bankId}&BranchId=${branchId}&&isActive=${status}`;
  } else {
    url =
      USERS_URL +
      `?Role=${role}&PageNumber=${pageNumber}&PageSize=${pageSize}&SearchString=${encodeURIComponent(
        searchString
      )}&OrderBy=${orderBy}&OrderType=${orderType}&Filter=${filter}&BankId=${bankId}&BranchId=${branchId}${productFilterString}&isActive=${status}`;
  }
  return await getData(url);
};

export const getConsultantUsers = async (params) => {
  let { role = "", bankId = "", branchId = "", applicationKeys = [] } = params;
  let url = "";

  if (role === "%23EC") {
    let productFilterString = "";
    applicationKeys?.forEach((el) => {
      productFilterString += `&ProductKey=${el.replace("#", "%23")}`;
    });
    url =
      USERS_URL +
      `?isActive=true&Role=${role}&BankId=${bankId}&BranchId=${branchId}${productFilterString}`;
  }
  return await getData(url);
};

export const getAllowedUsers = async () => {
  return getData(userUrl.rolesAllowed);
};

export const validateUser = async (key) => {
  let url = userUrl.validateLink + `/${key}`;
  return await postData(url);
};

export const getUserById = async (key) => {
  let url = USERS_URL + `/${key}`;

  return await getData(url);
};
export const UpdateUserById = async (key, payload) => {
  let url = USER_URL + `/${key}`;

  return await updateData(url, payload);
};

export const getUserRoles = async () => {
  return await getData(userUrl.roles);
};

export const getUserPermissions = async () => {
  return await getData(userUrl.userClaims);
};

export const updateUserClaims = async (key, data) => {
  let url = `${USERS_URL}/${key}${userUrl.allClaims}`;
  return await updateData(url, data);
};

export const getGridConfiguration = async () => {
  return getData(commonUrl.gridConfigurations);
};

export const fetchUsersProfilePicture = (id) => {
  const url = getUsersProfilePictureUrl(id);
  return axios.get(url, { responseType: "blob" }).then((response) => {
    try {
      if (response.status === 200) {
        return response;
      }
    } catch (e) {}
  });
};

export const fetchTeamMemberLogo = (imageURL) => {
  const url = fetchBranchLogoUrl(imageURL);
  return axios.get(url, { responseType: "blob" }).then((response) => {
    try {
      if (response.status === 200) {
        return response;
      }
    } catch (e) {}
  });
};
export const getUserOrganizationDetailById = async (userId) => {
  let url = RESULT_ANALYSIS_KEY + `/users/organisation/?userList[0]=${userId}`;

  return await getData(url);
};
export const getOrganization = async (userId) => {
  let url = `/resultanalysis/api/v1/esg/questions/questionnaire?PageNumber=1&PageSize=100&userId=${userId}&IsActive=true&IsDraft=false&timeStamp=${new Date().toUTCString()}`;
  return await getData(url);
};

export const downloadOrganizationDetail = async (userId, questionnaireId) => {
  let url = `/resultanalysis/api/v1/esg/questionnaire/download?userId=${userId}&questionnaireId=${questionnaireId}&timeStamp=${new Date().toUTCString()}`;
  return await downloadData(url);
};

export const getUserNotificationById = async (
  userId,
  pageNumber,
  pageSize,
  isClient
) => {
  let url = `/vds/api/v1/user/${userId}/notifications/history?PageNumber=${pageNumber}&PageSize=${pageSize}&ClientsOnly=${isClient}`;
  return await getData(url);
};

export const updateNotificationStatus = async (userId, data) => {
  let url = `/vds/api/v1/user/${userId}/notifications/status?status=READ`;
  return await updateData(url, data);
};
export const downloadApiUserStats = async (userId) => {
  let url = `/resultanalysis/api/v1/bwaFile/${userId}/download`;
  return await downloadData(url);
};
export const resetCalculationCounter = async (userId) => {
  let url = `/payment/api/v1/reset-free-plan?userId=${userId}`;
  return await updateData(url);
};
export const getSubscriptionsInfo = async (userId) => {
  let url = `/vds/api/v1/users/${userId}/subscription-info`;
  return await getData(url);
};
